import React from 'react';

import {
  DataTable,
  DataTableFilterMetaData,
  DataTableSortMeta,
  DataTableStateEvent
} from 'primereact/datatable';
import type { Task } from 'types/interfaces';

import { getDistributionColumns } from '../columns';

interface Props {
  tasks: Task[];
  multiSortMeta: DataTableSortMeta[] | undefined | null;
  onSortChange: (e: DataTableStateEvent) => void;
  filters: Record<string, DataTableFilterMetaData>;
  onFiltersChange: (e: DataTableStateEvent) => void;
  selectedAuto: Record<number, boolean>;
  onAutoSelectionChange: (next: Record<number, boolean>) => void;
  tableControlsEnabled?: boolean;
}

export const DistributionTasksTable: React.FC<Props> = ({
  tasks,
  multiSortMeta,
  onSortChange,
  filters,
  onFiltersChange,
  selectedAuto,
  onAutoSelectionChange,
  tableControlsEnabled = true
}) => (
  <DataTable
    value={tasks}
    dataKey="id"
    size="small"
    scrollable
    scrollHeight="55vh"
    lazy
    sortMode="multiple"
    removableSort
    multiSortMeta={tableControlsEnabled ? multiSortMeta ?? undefined : undefined}
    onSort={tableControlsEnabled ? onSortChange : undefined}
    filters={tableControlsEnabled ? filters : undefined}
    onFilter={tableControlsEnabled ? onFiltersChange : undefined}
    selectionMode="checkbox"
    selection={tasks.filter((t) => selectedAuto[Number(t.id)])}
    onSelectionChange={(e) => {
      const next: Record<number, boolean> = {};
      (e.value as Task[]).forEach((t) => {
        next[Number(t.id)] = true;
      });
      onAutoSelectionChange(next);
    }}
    emptyMessage="Нет нарядов для выбранных условий"
  >
    {getDistributionColumns({ tableControlsEnabled })}
  </DataTable>
);
